module.exports = __webpack_public_path__ + "img/big-title.92f58989.png";